import React from 'react';
import { Props } from '../types';
import { UserType } from '../../types/user-type';

interface FooterProps extends Props {
  navigationItems: Record<UserType, unknown>;
  countryLocaleCode: string;
  userTypeFromSlug: UserType;
  isSalzburg: boolean;
}

const Footer = 'rcm-footer' as React.ElementType;

// TODO correct typing of storyblok repsones
export const RcmFooter = (props: FooterProps): JSX.Element => {
  const { navigationItems, countryLocaleCode, userTypeFromSlug, isSalzburg } = props;

  // We need the custom component, otherwise jsx does not render the attributes
  return (
    <Footer
      sitemap-links={JSON.stringify(navigationItems)}
      user-type-from-slug={userTypeFromSlug}
      country-code={countryLocaleCode}
      is-salzburg={isSalzburg}
    >
      {/*
       * NOTE: Only works if renderTree is defined using the function keyword!
       *
       * To avoid managing the arguments that are passed to renderTree,
       * we pass component state as the thisArg to the mapping function.
       */}
    </Footer>
  );
};
